<template>
  <div class="text-center">
    <img alt="Lihavapp logo small" class="logo-small" src="../assets/logo-small.svg" />
    <form class="form-register" @submit.prevent="register">
  
      <label for="username" class="sr-only">Username</label>
      <input
        type="text"
        id="username"
        name="username"
        class="form-control"
        placeholder="Username"
        v-model="username"
        required
        autofocus
      >
      <label for="password" class="sr-only">Password</label>
      <input
        type="password"
        id="password"
        name="password"
        class="form-control"
        placeholder="Password"
        v-model="password"
        required
      >
      <label for="password_confirmation" class="sr-only">Password_confirmation</label>
      <input
        type="password"
        id="password_confirmation"
        name="password_confirmation"
        class="form-control"
        placeholder="Password confirmation"
        v-model="password_confirmation"
        required
      >

      <button class="btn btn-lg btn-primary btn-block" type="submit">Register</button>
    </form>
  </div>
</template>

<script>
import { store } from "@/store.js";

export default {
  name: "RegisterView",
  data: function() {
    return {
      store: store,
      username: "",
      password: "",
      password_confirmation: ""
    };
  },
  methods: {
    register: function(event) {
      let self = this;
      this.axios
        .post(
          "auth/register",
          {
            username: this.username,
            password: this.password,
            password_confirmation: this.password_confirmation
          },
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              'Content-Type': 'application/json',
            }
          }
        )
        .then(function(response) {
          self.flashSuccess('Registration successful, please login');
          self.$router.push({ name: "login" });
        })
        .catch(function(error) {
          self.flashError('Registration failed, please try again');
          console.log(error);
        })
        .then(function() {
          // always executed
        });
    }
  }
};
</script>

<style>
.nav a {
  color: red;
}

.form-register {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
.form-register .checkbox {
  font-weight: 400;
}
.form-register .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}
.form-register .form-control:focus {
  z-index: 2;
}
.form-register input[type="text"] {
  margin-bottom: 10px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-register input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}


</style>